// extracted by mini-css-extract-plugin
module.exports = {"avatar":"Author_avatar__RXCOF"};